/* eslint-disable no-restricted-syntax */
export default function getAddressObject(addressComponents) {
  const ShouldBeComponent = {
    street: ['street_number'],
    postalCode: ['postal_code'],
    zipCode: ['postal_code'],
    streetName: ['street_address', 'route'],
    province: [
      'administrative_area_level_1',
      'administrative_area_level_2',
      'administrative_area_level_3',
      'administrative_area_level_4',
      'administrative_area_level_5',
    ],
    state: [
      'administrative_area_level_1',
      'administrative_area_level_2',
      'administrative_area_level_3',
      'administrative_area_level_4',
      'administrative_area_level_5',
    ],
    city: [
      'locality',
      'sublocality',
      'sublocality_level_1',
      'sublocality_level_2',
      'sublocality_level_3',
      'sublocality_level_4',
    ],
    country: ['country'],
  };

  const address = {
    street: '',
    postalCode: '',
    zipCode: '',
    streetName: '',
    province: '',
    state: '',
    city: '',
    country: '',
  };
  addressComponents.forEach((component) => {
    for (const shouldBe in ShouldBeComponent) {
      if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
        if (shouldBe === 'country' || shouldBe === 'state' || shouldBe === 'province') {
          address[shouldBe] = component.short_name;
        } else {
          address[shouldBe] = component.long_name;
        }
      }
    }
  });
  return address;
}
